import React from 'react';
import { Container, Typography, Link } from '@mui/material';
import { styled } from '@mui/system';

const GradientContainer = styled(Container)(({ theme }) => ({
  background: 'linear-gradient(to bottom, #FFFFFF, #ADD8E6, #93b7f0ff, #D3D3D3)',
  padding: theme.spacing(4),
  borderRadius: theme.shape.borderRadius,
  marginTop: theme.spacing(4),
  lineHeight: '1.8',
   maxWidth: '1000px',
}));

const PrivacyPolicy = () => {
  return (
    <GradientContainer maxWidth="lg">
      <Typography variant="h4" gutterBottom>
        Privacy Policy
      </Typography>

      <Typography variant="subtitle1" gutterBottom>
        Effective date: May 25, 2018
      </Typography>

      <Typography paragraph>
        Intrinsic Clinical Systems (“us”, “we”, or “our”) operates the website{' '}
        <Link href="https://www.intrinsiccs.com/" target="_blank" rel="noopener noreferrer">
          www.intrinsiccs.com
        </Link>.
      </Typography>

      <Typography paragraph>
        This page informs you of our policies regarding the collection, use, and disclosure of
        personal data when you use our Service and the choices you have associated with that data.
      </Typography>

      <Typography paragraph>
        We use your data to provide and improve the Service. By using the Service, you agree to the
        collection and use of information in accordance with this policy. Unless otherwise defined
        in this Privacy Policy, terms used in this Privacy Policy have the same meanings as in our{' '}
        <Link href="https://www.intrinsiccs.com/terms" target="_blank" rel="noopener noreferrer">
          Terms and Conditions
        </Link>.
      </Typography>

      <Typography variant="h5" gutterBottom>
        Information Collection And Use
      </Typography>

      <Typography paragraph>
        We collect several different types of information for various purposes to provide and
        improve our Service to you.
      </Typography>

      <Typography variant="h6" gutterBottom>
        Types of Data Collected
      </Typography>

      <Typography variant="subtitle1" gutterBottom>
        Personal Data
      </Typography>

      <Typography paragraph>
        While using our Service, we may ask you to provide us with certain personally identifiable
        information that can be used to contact or identify you (“Personal Data”). Personally
        identifiable information may include, but is not limited to:
      </Typography>

      <Typography component="ul">
        <li>Email address</li>
        <li>First name and last name</li>
      </Typography>

      <Typography variant="h5" gutterBottom>
        Use of Data
      </Typography>

      <Typography paragraph>
        Intrinsic Clinical Systems uses the collected data for various purposes:
      </Typography>

      <Typography component="ul">
        <li>To provide access to the Service</li>
        <li>To notify you about changes to our Service</li>
        <li>To allow you to participate in interactive features of our Service when you choose to do so</li>
        <li>To provide customer care and support</li>
        <li>To provide analysis or valuable information so that we can improve the Service</li>
        <li>To monitor the usage of the Service</li>
        <li>To detect, prevent and address technical issues</li>
      </Typography>

      {/* ---------------- New Content Starts Here ---------------- */}
      <Typography variant="h5" gutterBottom>
        Transfer Of Data
      </Typography>

      <Typography paragraph>
        Your information, including Personal Data, may be transferred to — and maintained on —
        computers located outside of your state, province, country or other governmental
        jurisdiction where the data protection laws may differ than those from your jurisdiction.
      </Typography>

      <Typography paragraph>
        If you are located outside United States and choose to provide information to us, please note
        that we transfer the data, including Personal Data, to the United States and process it there.
      </Typography>

      <Typography paragraph>
        Your consent to this Privacy Policy, followed by your submission of such information,
        represents your agreement to that transfer.
      </Typography>

      <Typography paragraph>
        Intrinsic Clinical Systems will take all steps reasonably necessary to ensure that your data
        is treated securely and in accordance with this Privacy Policy, and no transfer of your
        Personal Data will take place to an organization or a country unless there are adequate
        controls in place including the security of your data and other personal information.
      </Typography>

      <Typography variant="h5" gutterBottom>
        Disclosure Of Data
      </Typography>

      <Typography variant="subtitle1" gutterBottom>
        Legal Requirements
      </Typography>

      <Typography paragraph>
        Intrinsic Clinical Systems may disclose your Personal Data in the good faith belief that such
        action is necessary to:
      </Typography>

      <Typography component="ul">
        <li>To comply with a legal obligation</li>
        <li>To protect and defend the rights or property of Intrinsic Clinical Systems</li>
        <li>To prevent or investigate possible wrongdoing in connection with the Service</li>
        <li>To protect the personal safety of users of the Service or the public</li>
        <li>To protect against legal liability</li>
      </Typography>

      <Typography variant="h5" gutterBottom>
        Security Of Data
      </Typography>

      <Typography paragraph>
        The security of your data is important to us, but remember that no method of transmission
        over the Internet, or method of electronic storage is 100% secure. While we strive to use
        commercially acceptable means to protect your Personal Data, we cannot guarantee its
        absolute security.
      </Typography>

      <Typography variant="h5" gutterBottom>
        Service Providers
      </Typography>

      <Typography paragraph>
        We may employ third party companies and individuals to facilitate our Service (“Service
        Providers”), to provide the Service on our behalf, to perform Service-related services or to
        assist us in analyzing how our Service is used.
      </Typography>

      <Typography paragraph>
        These third parties have access to your Personal Data only to perform these tasks on our
        behalf and are obligated not to disclose or use it for any other purpose.
      </Typography>

      <Typography variant="h5" gutterBottom>
        Changes To This Privacy Policy
      </Typography>

      <Typography paragraph>
        We may update our Privacy Policy from time to time. We will notify you of any changes by
        posting the new Privacy Policy on this page. You are advised to review this Privacy Policy
        periodically for any changes. Changes to this Privacy Policy are effective when they are
        posted on this page.
      </Typography>

      <Typography variant="h5" gutterBottom>
        Contact Us
      </Typography>

      <Typography paragraph>
        If you have any questions about this Privacy Policy, please contact us using the “Contact”
        link at the top of this page.
      </Typography>
      {/* ---------------- New Content Ends Here ---------------- */}
    </GradientContainer>
  );
};

export default PrivacyPolicy;
